import { useState } from 'react';
import { getDocumentTable } from '../actions';
import { useDispatch, useSelector } from 'react-redux';
import { ActionClickHandler } from '../types';

interface Props {
  api: any;
  allSections: any;
}

export const useActionsHandlers = ({ api, allSections }: Props) => {
  const [pdfErrorMessage, setPdfErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const [form_type, process_id] = useSelector((state: any) => [
    state.forms.form_type,
    state.forms.process_id,
  ]);

  const getErrorFieldName = (sections: any, controlId: string) => {
    for (let section of sections) {
      for (let control of section?.controls) {
        if (control.id === controlId || control.field === controlId) {
          return control.title.ru;
        }
        if (control.columns) {
          for (let column of control?.columns) {
            if (column.id === controlId) {
              return column.title.ru;
            }
          }
        }
      }
    }
    return undefined;
  };

  const signAndFormPdf = (id: string) => {
    setPdfErrorMessage(null);
    const {
      moduleApi,
      options: { baseUrl },
    } = api;
    setIsLoading(true);
    const result = `${baseUrl}/documents/template/${id}/ru`;

    moduleApi.getFileByUrl(result, 'blob', {
      success: async (response) => {
        const filename = response.headers
          .get('content-disposition')
          .split(';')
          .find((n) => n.includes('filename*='))
          .replace("filename*=utf-8''", '')
          .trim();
        const filenameDecoded = decodeURI(filename);
        const url = URL.createObjectURL(response.data);
        const a = document.createElement('a');
        a.download = filenameDecoded;
        a.href = url;
        a.target = '_self';

        a.click();

        setIsLoading(false);
        getDocumentTable(form_type, process_id)(dispatch);
      },
      error: async (error) => {
        const errorJson = JSON.parse(await error.response.data.text());
        let errorMessage;

        console.log('SignGridComponent ERR:', errorMessage);

        if (errorJson.detail?.field_errors) {
          const fieldErrors = errorJson.detail?.field_errors;
          const firstErrorKey = Object.keys(fieldErrors)[0];
          errorMessage = getErrorFieldName(allSections, firstErrorKey);
          if (errorMessage !== undefined) {
            setPdfErrorMessage(
              `${errorMessage} - ${fieldErrors[firstErrorKey][0]}`,
            );
          } else {
            setPdfErrorMessage('Произошла ошибка. Попробуйте позже.');
          }
        } else {
          errorMessage = errorJson.detail.ru;
          setPdfErrorMessage(errorMessage);
        }
        setIsLoading(false);
      },
    });
  };

  const deletePdf = (id: string) => {
    setPdfErrorMessage(null);
    const {
      moduleApi,
      options: { baseUrl },
    } = api;
    setIsLoading(true);

    const result = `${baseUrl}/documents/reset/${id}`;

    moduleApi.post(result, undefined, {
      success: async (response) => {
        console.log('suc', response);

        setIsLoading(false);
        getDocumentTable(form_type, process_id)(dispatch);
      },
      error: async (error) => {
        const errorJson = JSON.parse(await error.response.data.text());
        let errorMessage;

        console.log('SignGridComponent ERR:', errorMessage);

        if (errorJson.detail?.field_errors) {
          const fieldErrors = errorJson.detail?.field_errors;
          const firstErrorKey = Object.keys(fieldErrors)[0];
          errorMessage = getErrorFieldName(allSections, firstErrorKey);
          if (errorMessage !== undefined) {
            setPdfErrorMessage(
              `${errorMessage} - ${fieldErrors[firstErrorKey][0]}`,
            );
          } else {
            setPdfErrorMessage('Произошла ошибка. Попробуйте позже.');
          }
        } else {
          errorMessage = errorJson.detail.ru;
          setPdfErrorMessage(errorMessage);
        }
        setIsLoading(false);
      },
    });
  };

  const handleClick: ActionClickHandler = (e, cell, action) => {
    const { rowId, status } = cell;

    e.preventDefault();
    // @ts-ignore
    const elemId = e.target.dataset.id;
    if (status === 20 && action === 'form') signAndFormPdf(rowId);

    if (status !== 20 && action === 'sign') {
      dispatch({ type: 'SET_ROW_ID', payload: rowId });
      dispatch({ type: `TOGGLE_${elemId}_MODAL`, payload: true });
    }

    if (status !== 20 && action === 'delete') deletePdf(rowId);
  };

  return { pdfErrorMessage, isLoading, handleClick };
};
